import { object, string } from 'yup';

export type DealTodo = {
  id: number;
  staff: {
    id: number;
    name: string;
  } | null;
  completed: boolean;
  dueDate: string | null;
  completedAt: string | null;
  title: string;
  memo: string | null;
  todoTemplateId: number | null;
};

export const STATUS_OPTIONS = [
  { label: '未完了', value: 'false' },
  { label: '完了', value: 'true' },
  { label: 'すべて', value: 'all' }
] as const satisfies Array<{ label: string; value: string }>;

export type DealTodoEdit = Omit<DealTodo, 'id' | 'completedAt'>;
export const buildInitialDealTodoEdit = (): DealTodoEdit => ({
  staff: null,
  completed: false,
  dueDate: null,
  title: '',
  memo: '',
  todoTemplateId: null
});

export const validationSchema = object().shape({
  title: string().required('入力してください')
});
